import type { PlayerType } from '@/types/dtos/player/response/player.dto';

/** Max concurrent players per type for a bound entity (mirrors event-service caps). */
export const PLAYER_TYPE_CAPS: Partial<Record<PlayerType, number>> = {
  stagePlayer: 1,
  screenPublisher: 2,
  roomPlayer: 10,
  onlinePlayer: 10,
  confidencePlayer: 4,
  houseCamPlayer: 1,
};

/** UI-only caps for stub sections (no backend type yet). */
export const STUB_PLAYER_CAPS = {
  speakerMonitor: 2,
  infoDisplay: 10,
} as const;

export function getPlayerTypeCap(type: PlayerType): number | undefined {
  return PLAYER_TYPE_CAPS[type];
}
